import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1b4c03cd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=1b4c03cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../dtviso-cos-direct/browser/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports